import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import tz from 'moment-timezone'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tenantId: "",
    minisiteUrl:"",
    protocol: "https://",
    subDomain:"arista.genamet.com",
    businessId: "",
    businessLogo: "",
    businessName: "",    
    businessType: "",
    businessWebsiteUrl: "",
    providerTitle: "",
    providerFirstName: "",
    providerLastName: "",
    providerEmail: "",
    providerId: "",
    providerColorCode: "",
    providerPhone: "", 
    providerQual: "",
    providerPic: "",
    locationName: "",
    clinicContactNumbers: "",
    clinicAddress: "",
    locationId: "",
    locationTz:"",
    clientTz:"",
    bookingData: {
        "customer_details": {
            "name": "",
            "email": "",
            "mobile": ""
        },
        "from": "",
        "to": "",
        "provider": {
            "first_name": "",
            "last_name": "",
            "unique_id": "",
            "color_code": ""
        },
        "facility": {
            "location_name": "",
            "unique_id": ""
        },
        "service_details": {
            "name": "",
            "code": "",
            "duration": "",
            "pre_service_buffer_time": "",
            "post_service_buffer_time": "",
            "unique_id": ""
        },
        "status": {
            "name": "Confirmed",
            "unique_id": "2a743038-3650-4621-8fb4-8cfbaf597158"
        }
    },
    loading: false,
    loadingMessage: "",
    error: false,
    errorMessage: ""
  },
  mutations: {
    UPDATE_TENANT_CONTEXT(state, payload) {
      state.tenantId = payload.Item.tenant_id.trim();
      localStorage.setItem("tenantId", JSON.stringify(payload.Item.tenant_id.trim()));
      
    },
    UPDATE_BUSINESS_CONTEXT(state, payload) {
      state.businessId = payload[0].id;
      state.businessName = payload[0].name;
      state.businessType = payload[0].type;
      state.businessWebsiteUrl = payload[0].website_url;
      state.businessLogo = payload[0].logo_file_name;
    },
    UPDATE_LOCATION_CONTEXT(state, payload) {     
      state.locationName = payload[0].location_name;
      state.locationId = payload[0].unique_id;
      state.locationTz = payload[0].location_tz;
      state.locationCurrency = payload[0].currency;
      state.clientTz = moment.tz.guess();
      state.mapUrlEmbedded = payload['0'].map_url_embeded;
      state.clinicContactNumbers = payload['0'].clinic_contact_numbers;
      state.clinicAddress = payload['0'].address;
    },
    UPDATE_PROVIDER_CONTEXT(state, payload) {
      state.providerTitle = payload[0].title;
      state.providerFirstName = payload[0].first_name;
      state.providerLastName = payload[0].last_name;
      state.providerEmail = payload[0].email;
      state.providerId = payload[0].unique_id;
      state.providerColorCode = payload[0].color_code;
      state.providerPhone = payload[0].mobile;
      state.providerQual = payload[0].qualifications;
      state.providerPic = payload[0].profile_pic_file_name;
      state.minisiteUrl = payload[0].mini_site_url;
    },
    SET_LOADING(state, payload) {
      state.loading = payload.loading;
      state.loadingMessage = payload.loadingMessage;
    },
    SET_ERROR(state, payload) {
      state.error = payload.error;
      state.errorMessage = payload.errorMessage;
    }
  },
  actions: {
    checkTenant({commit}) {
      commit('SET_LOADING', {"loading": true, "loadingMessage": "Loading, please wait ... "});
      // tenant checking ... 
      // tenant checking ... 
      //let url = process.env.VUE_APP_TENANT_API_BASE+"/development/tenanturlmap/";
      // Anuj 11th feb, trying new tenant url
      let url = process.env.VUE_APP_GET_TENANT_URL;
      // debugger;
      let hostName = window.location.hostname; 
    //  let hostName = "pablo-clinic-3012221229.dev.genamet.com";
      let payload = '{'+
          '"operation": "read",'+
          '"payload": {'+
              '"TableName":"tenantURLMap",'+
              '"Key":{'+
                  '"url":"'+hostName+'"'+
              '}'+
          '}'+
      '}';
      axios.post(
        url, 
        payload,
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
      ).then(response =>{
        commit('UPDATE_TENANT_CONTEXT', response.data);
        commit('SET_LOADING', {"loading": false, "loadingMessage": ""});
        commit('SET_ERROR', {"error": false, "errorMessage": ""});
      }).catch(e => {
        commit('SET_LOADING', {"loading": false, "loadingMessage": ""});
        commit('SET_ERROR', {"error": true, "errorMessage": "Sorry, you are not a valid subscriber!"});
      });
      // -- tenant checking ends 
    },
    getBusinessSetup({commit}, payload) {
      commit('SET_LOADING', {"loading": true, "loadingMessage": "Loading, please wait ... "});
      // get business setup ... 
      let url = process.env.VUE_APP_FRONTEND_API_BASE+"/api/business-setup/?isac=1";
      
      axios.get(
        url, 
        {
            headers: {
                'Content-Type': 'application/json',
                'x_tenant_id': payload
            }
        }
      ).then(response =>{
        commit('UPDATE_BUSINESS_CONTEXT', response.data);
        commit('SET_LOADING', {"loading": false, "loadingMessage": ""});
        commit('SET_ERROR', {"error": false, "errorMessage": ""});
      }).catch(e => {
        commit('SET_LOADING', {"loading": false, "loadingMessage": ""});
        commit('SET_ERROR', {"error": true, "errorMessage": "Sorry, you are not a valid subscriber!"});
      });
      // -- get business setup ends 
    },
    getLocation({commit}, payload) {
      commit('SET_LOADING', {"loading": true, "loadingMessage": "Loading, please wait ... "});
      // get location ... 
      let url = process.env.VUE_APP_FRONTEND_API_BASE+"/api/location/?isac=1&lid="+payload.locationId;
      
      axios.get(
        url, 
        {
            headers: {
                'Content-Type': 'application/json',
                'x_tenant_id': payload.x_tenant_id
            }
        }
      ).then(response =>{
        commit('UPDATE_LOCATION_CONTEXT', response.data);
        commit('SET_LOADING', {"loading": false, "loadingMessage": ""});
        commit('SET_ERROR', {"error": false, "errorMessage": ""});
      }).catch(e => {
        commit('SET_LOADING', {"loading": false, "loadingMessage": ""});
        commit('SET_ERROR', {"error": true, "errorMessage": "Sorry, you are not a valid subscriber!"});
      });
      // -- get location ends 
    },
    getStaff({commit}, payload) {
      commit('SET_LOADING', {"loading": true, "loadingMessage": "Loading, please wait ... "});
      // get staff ... 
      let url = process.env.VUE_APP_FRONTEND_API_BASE+"/api/staff/?isac=1&stid="+payload.staffId+"&lid=";
      
      axios.get(
        url, 
        {
            headers: {
                'Content-Type': 'application/json',
                'x_tenant_id': payload.x_tenant_id
            }
        }
      ).then(response =>{
        commit('UPDATE_PROVIDER_CONTEXT', response.data);
        commit('SET_LOADING', {"loading": false, "loadingMessage": ""});
        commit('SET_ERROR', {"error": false, "errorMessage": ""});
      }).catch(e => {
        commit('SET_LOADING', {"loading": false, "loadingMessage": ""});
        commit('SET_ERROR', {"error": true, "errorMessage": "Sorry, you are not a valid subscriber!"});
      });
      // -- get staff ends 
    },
  },
  getters: {
    tenantId: state => state.tenantId,
    minisiteUrl: state=>state.minisiteUrl,
    subDomain: state => state.subDomain,
    protocol: state => state.protocol,
    businessId: state => state.businessId,
    businessLogo: state => state.businessLogo,
    businessName: state => state.businessName,
    businessType: state => state.businessType,
    businessWebsiteUrl: state => state.businessWebsiteUrl,
    providerTitle: state => state.providerTitle,
    providerFirstName: state => state.providerFirstName,
    providerLastName: state => state.providerLastName,
    providerEmail: state => state.providerEmail,
    providerId: state => state.providerId,
    providerColorCode: state => state.providerColorCode,
    providerPhone: state => state.providerPhone,
    providerQual: state => state.providerQual,
    providerPic: state => state.providerPic,
    locationName: state => state.locationName,
    clinicContactNumbers: state => state.clinicContactNumbers,
    clinicAddress: state => state.clinicAddress,
    locationId: state => state.locationId,
    locationTz: state => state.locationTz,
    locationCurrency: state => state.locationCurrency,
    mapUrlEmbedded: state => state.mapUrlEmbedded,
    clientTz: state => state.clientTz,
    loading: state => state.loading,
    loadingMessage: state => state.loadingMessage,
    error: state => state.error,
    errorMessage: state => state.errorMessage
  }
})
